
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import AddUser from "./AddUser";
import UserList from "./UserList";
import UserPermissions from "./UserPermissions";
import UserActivityLogs from "./UserActivityLogs";
import Navigationbar from "../Navigationbar";
import withNavigate from "../../Global_files/WithNavigate";
import { getFreshToken } from '../../custom_libraries/serverRequests';

const UserAccounts = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const [activeSubTab, setActiveSubTab] = useState(0); // Default to first tab

  const subTabs = [
    { label: "Add User", content: <AddUser /> },
    { label: "User List", content: <UserList /> },
    { label: "User Permissions", content: <UserPermissions /> },
    { label: "User Activity", content: <UserActivityLogs /> },
  ];

  // Set the subtab based on passed state from Link
  useEffect(() => {
    validateSignedIn();
    if (location.state?.activeSubTab) {
      const tabIndex = subTabs.findIndex(tab => tab.label === location.state.activeSubTab);
      if (tabIndex !== -1) setActiveSubTab(tabIndex);
    }
  }, [location.state]);

  const validateSignedIn = async () => {
      let is_fresh_token = await getFreshToken()
      if (!is_fresh_token) {
          navigate("/");
          return
      }
  }

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      {/* Navigation Bar */}
      <Navigationbar />
      <div style={{ marginLeft: "8.5%" }}>
        {/* Subtabs */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 1, ml: 3 }}>
          <Tabs
            value={activeSubTab}
            onChange={(e, newValue) => setActiveSubTab(newValue)}
            textColor="primary"
            indicatorColor="primary"
          >
            {subTabs.map((tab, index) => (
              <Tab key={index} label={tab.label} 
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "#d1e8ff",
                  fontWeight: 550,
                },
              }}
              />
            ))}
          </Tabs>
        </Box>

        {/* Tab Content */}
        <Box sx={{ p: 0.5 }}>
          <Typography component="div">
            {subTabs[activeSubTab].content}
          </Typography>
        </Box>
      </div>
    </div>
  );
};

export default withNavigate(UserAccounts);

